
import { computed, defineComponent } from 'vue'

import NewModal from '@/common/new-components/NewModal/index.vue'
import NewSelect from '@/ui-kit/NewSelect/index.vue'

export default defineComponent({
    components: {
        NewModal,
        NewSelect,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        isChild: {
            type: Boolean,
            default: false,
        },
        parent: {
            type: String,
            default: '-',
        },
        child: {
            type: String,
            default: '-',
        },
    },
    emits: ['submit', 'cancel'],
    setup(props, { emit }) {
        const onSubmit = () => {
            if (props.loading) return
            emit('submit')
        }

        const onCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        const getTitle = computed(() => {
            return props.isChild
                ? 'Открепление от родительского направления'
                : 'Открепление дочернего направления'
        })

        return {
            onSubmit,
            onCancel,
            getTitle,
        }
    },
})
